/* cji-opt-dropdowns
   The personalizer's size step drew ONE CARD PER VARIANT. On the 5 name charm
   necklace that is 7 metal thicknesses x 3 chain lengths = 21 cards in one flat
   list, unreadable on a phone, which is 93% of sessions.
   The section now renders a dropdown per option. The original grid is still in
   the DOM with all of its data attributes and handlers; it is only hidden, and
   changing a dropdown finds the matching button and clicks it. No existing
   configurator JS was touched, which matters because it drives several product
   types, and if this script fails the buttons simply stay visible. */
(function () {
  var CSS =
    '.cji-opt-selects{display:flex;flex-wrap:wrap;gap:14px;margin:0 0 14px}' +
    '.cji-opt-field{display:flex;flex-direction:column;gap:5px;flex:1 1 210px;min-width:180px}' +
    /* cji-opt-readable, 26 Oct 2026. Jamie: the labels and prices on the
       choices were too small and grey. 11px grey capitals became 16px dark,
       matching the family picker's Metal and Size rows. */
    '.cji-opt-label{font-size:16px;font-weight:700;letter-spacing:.01em;text-transform:none;opacity:1;color:#2a1a0c}' +
    '.cji-opt-cur{font-size:16px;font-weight:500;color:#2a1a0c}' +
    '.cji-opt-field.cji-opt-boxed{flex:1 1 100%;flex-direction:row;flex-wrap:wrap;align-items:baseline;gap:8px}' +
    '.cji-opt-field.cji-opt-boxed .cji-opt-select{display:none}' +
    /* The theme gives a span inside a label a left margin of up to 20px. */
    '.cji-opt-field.cji-opt-boxed .cji-opt-label,.cji-opt-field.cji-opt-boxed .cji-opt-cur{display:inline;margin:0!important}' +
    '.cji-opt-field .cji-opt-label{margin:0!important}' +
    '.cji-opt-boxes{flex:1 1 100%;display:flex;flex-wrap:wrap;gap:8px;margin:-5px 0 4px}' +
    '.cji-opt-boxes .cji-opt-box{appearance:none;display:inline-block;width:auto!important;min-width:0!important;' +
    'margin:0!important;border:1px solid #d8cdb8!important;background:#fff!important;color:#2a1a0c!important;' +
    'box-shadow:none!important;border-radius:8px!important;padding:8px 12px!important;font-size:14px!important;' +
    'font-weight:500!important;line-height:1.2!important;letter-spacing:0!important;text-transform:none!important;' +
    'min-height:44px;text-align:center;cursor:pointer}' +
    '.cji-opt-boxes .cji-opt-box::before,.cji-opt-boxes .cji-opt-box::after{content:none!important;display:none!important}' +
    '.cji-opt-boxes .cji-opt-box small{display:block;font-size:14.5px;font-weight:500;color:#3b2414;margin-top:4px}' +
    '.cji-opt-boxes .cji-opt-box.on{border:2px solid #6e1f2a!important;padding:7px 11px!important;background:#fbf4ea!important;font-weight:700!important}' +
    '.cji-opt-boxes .cji-opt-box.on small{color:#1a1a1a;font-weight:600}' +
    '.cji-opt-boxes .cji-opt-box.off{opacity:.5}' +
    /* Ring sizes: seventeen of them, so a tighter grid of smaller boxes. */
    '.cji-opt-boxes.cji-opt-num{display:grid;grid-template-columns:repeat(auto-fill,minmax(70px,1fr))}' +
    '.cji-opt-boxes.cji-opt-num .cji-opt-box{padding:8px 3px!important;font-size:15px!important}' +
    '.cji-opt-boxes.cji-opt-num .cji-opt-box.on{padding:7px 2px!important}' +
    '.cji-opt-boxes.cji-opt-num .cji-opt-box small{font-size:13px}' +
    '.cji-opt-boxes .cji-opt-box:focus-visible{outline:2px solid #6e1f2a;outline-offset:2px}' +
    /* The theme paints its own chevron on select, from an SVG with no intrinsic
       size, and repaints it on select:focus. A bare background:#fff here clears
       the image but leaves repeat at its default, so the moment the field took
       focus the focus rule put the chevron back and it tiled across the whole
       control as a row of zigzags. Jamie caught it on a merged signet, 25
       August. State the background longhands, and restate them for focus,
       where select:focus would otherwise outrank a plain class. */
    '.cji-opt-select{padding:11px 12px;font-size:15px;border:1px solid rgba(0,0,0,.28);' +
    'border-radius:6px;background-color:#fff;background-image:none;width:100%}' +
    '.cji-opt-select:focus,.cji-opt-select:focus-visible,.cji-opt-select:hover{' +
    'background-image:none;background-repeat:no-repeat}' +
    '.cji-opt-select:focus-visible{outline:2px solid #c6a24a;outline-offset:1px}' +
    /* The ring size block owns the size on a ring page: it knows what QG holds,
       what a size costs and who to call for the rest. Two controls for one
       choice is worse than either. Hide the duplicate, keep it in the DOM
       because it is half of what resolves the variant. */
    '.cji-opt-field.cji-opt-dupe{display:none}' +
    '#cji-variant-grid.cji-grid-hidden{display:none}';
  function init() {
    var wrap = document.getElementById('cji-opt-selects');
    var grid = document.getElementById('cji-variant-grid');
    if (!wrap || !grid) return;
    /* The label above the select says Ring Size already; on a single option
       product the step heading said Select Your Size too, so the dropdown
       carries the label and the heading stays for the step, not the field. */
    var s = document.createElement('style');
    s.textContent = CSS;
    document.head.appendChild(s);
    grid.classList.add('cji-grid-hidden');   // only hide once this script runs
      /* Hide the size dropdown only where the ring size block is on the page to
         take its place. */
      /* Hide the duplicate only where the ring size block really offers sizes.
         If its rows are not numeric the block is not usable as a size control
         and hiding this one would leave the page with no way to choose. */
      var rsSec = document.querySelector('.cji-ring-size');
      var rsRow = rsSec && rsSec.querySelector('.cji-rs-item');
      var rsOk = rsRow && !isNaN(parseFloat(rsRow.dataset.size));
      /* The personalizer has no .cji-ring-size block. It carries its own ring
         size step, step 3, which writes properties[Ring Size]. Jamie, 4 Sep
         2026: "ring size needs to be removed from step 1. It's already on step
         3." That step writes a PROPERTY and does not resolve the variant, so
         this dropdown is only safe to hide there when it has nothing to
         choose: one value, a placeholder, with price set by the metal. Hiding
         a real multi value size there would leave the price stuck on whatever
         variant loaded. */
      var persRs = !!document.querySelector(
        '.cji-size-options input[name="properties[Ring Size]"]');
      [].forEach.call(wrap.querySelectorAll('.cji-opt-field'), function (f) {
        var lab = f.querySelector('.cji-opt-label');
        var name = lab ? lab.textContent.trim().toLowerCase() : '';
        if (name !== 'ring size' && name !== 'size') return;
        var sel = f.querySelector('.cji-opt-select');
        var placeholder = !!sel && sel.options.length <= 1;
        if (rsOk || (persRs && placeholder)) { f.classList.add('cji-opt-dupe'); }
      });
      /* With the size field hidden, a step headed "Select Your Size" sits above
         a metal dropdown and reads as a mistake. The heading is chosen in
         cji-personalizer.liquid, which is at Shopify's 256 KB asset ceiling with
         221 bytes to spare, so the correction is made here instead. Only ever
         applied when a size field was actually hidden. */
      if (wrap.querySelector('.cji-opt-field.cji-opt-dupe')) {
        var shown = [].filter.call(wrap.querySelectorAll('.cji-opt-field'),
          function (f) { return !f.classList.contains('cji-opt-dupe'); });
        var heads = document.querySelectorAll('#step-1 .cji-step-heading');
        var head = heads.length ? heads[0] : null;
        if (head && /select your size/i.test(head.textContent)) {
          var names = shown.map(function (f) {
            var l = f.querySelector('.cji-opt-label');
            return l ? l.textContent.trim().toLowerCase() : '';
          });
          var sizey = names.some(function (n) {
            return /size|width|length/.test(n); });
          if (!sizey) {
            head.textContent = (names.length === 1 && /metal/.test(names[0]))
              ? 'Choose Your Metal' : 'Select Your Option';
          }
        }
      }
    /* Jamie, 25 August: 17 ring sizes as tiles is a screen and a half of
       scrolling on a phone, so a single option with many values now renders
       here too. The tiles showed a price per size and the dropdown must not
       lose it, so each option takes the price from its own hidden button.
       Read from the DOM rather than duplicated in Liquid: the personalizer
       section sits against the 256 KB template cap. */
    if (wrap.querySelectorAll('.cji-opt-select').length === 1) {
      var sel = wrap.querySelector('.cji-opt-select');
      Array.prototype.forEach.call(sel.options, function (opt) {
        var btn = grid.querySelector('.cji-variant-btn[data-title="' +
                  opt.value.replace(/"/g, '\\"') + '"]');
        if (!btn) return;
        var p = btn.querySelector('.cji-variant-price');
        if (p && p.textContent.trim()) {
          opt.textContent = opt.value + '\u00a0\u00a0\u00a0' + p.textContent.trim();
        }
        if (btn.dataset.available === 'false') { opt.disabled = true; }
      });
    }
    /* cji-opt-boxes, 26 Oct 2026. Jamie: "Do the same for the size boxes on
       the personalized pages", after the family picker's boxes were made
       readable. A short option is drawn as boxes, each with the price of that
       choice with the others held. The select stays in the DOM, hidden, and a
       tap sets it and fires change, so every listener on it (the one below, the
       ring size block in theme.liquid) still runs. A long row stays a dropdown:
       17 ring sizes as tiles was a screen and a half (Jamie, 25 August). */
    var fields = [].slice.call(wrap.querySelectorAll('.cji-opt-field'));
    var sels = fields.map(function (f) { return f.querySelector('.cji-opt-select'); });
    var allBtns = grid.querySelectorAll('.cji-variant-btn');
    function find(vals) {
      var want = vals.join(' / ');
      for (var i = 0; i < allBtns.length; i++) {
        if ((allBtns[i].dataset.title || '') === want) return allBtns[i];
      }
      return null;
    }
    var rows = [];
    function render() {
      var vals = sels.map(function (x) { return x ? x.value : ''; });
      rows.forEach(function (r) {
        r.cur.textContent = vals[r.k];
        r.items.forEach(function (it) {
          var v = vals.slice(); v[r.k] = it.val;
          var b = find(v), on = vals[r.k] === it.val;
          it.el.classList.toggle('on', on);
          it.el.setAttribute('aria-pressed', on ? 'true' : 'false');
          var p = b && b.querySelector('.cji-variant-price');
          it.pr.textContent = p ? p.textContent.trim() : '';
          it.el.classList.toggle('off', !b || b.dataset.available === 'false');
        });
      });
    }
    fields.forEach(function (f, k) {
      var sel = sels[k];
      if (!sel || f.classList.contains('cji-opt-dupe')) return;
      var opts = Array.prototype.slice.call(sel.options);
      /* Jamie, 26 Oct 2026: "Do the same for the ring size dropdown". A long
         row of plain numbers (ring sizes) is boxed too, in size order; any
         other long row stays a dropdown. */
      var num = opts.every(function (o) { return /^\d+(\.\d+)?$/.test(o.value.trim()); });
      if (sel.options.length < 2 || (sel.options.length > 12 && !num)) return;
      if (num) opts.sort(function (a, b) { return parseFloat(a.value) - parseFloat(b.value); });
      var lab = f.querySelector('.cji-opt-label');
      var cur = document.createElement('span');
      cur.className = 'cji-opt-cur';
      if (lab) lab.parentNode.insertBefore(cur, lab.nextSibling);
      f.classList.add('cji-opt-boxed');
      var row = document.createElement('div');
      row.className = 'cji-opt-boxes' + (num ? ' cji-opt-num' : '');
      row.setAttribute('role', 'group');
      if (lab) row.setAttribute('aria-label', lab.textContent.trim());
      var r = { k: k, cur: cur, items: [] };
      opts.forEach(function (opt) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'cji-opt-box';
        b.appendChild(document.createTextNode(opt.value));
        var pr = document.createElement('small');
        b.appendChild(pr);
        b.addEventListener('click', function () {
          var v = sels.map(function (x) { return x ? x.value : ''; });
          v[k] = opt.value;
          /* A combination the page does not sell: take the first version that
             has this value, so the tap always lands on something real. */
          if (!find(v)) {
            for (var i = 0; i < allBtns.length; i++) {
              var t = (allBtns[i].dataset.title || '').split(' / ');
              if (t[k] === opt.value) { v = t; break; }
            }
          }
          sels.forEach(function (x, i) { if (x && v[i] != null) x.value = v[i]; });
          sel.dispatchEvent(new Event('change', { bubbles: true }));
          render();
        });
        row.appendChild(b);
        r.items.push({ val: opt.value, el: b, pr: pr });
      });
      f.parentNode.insertBefore(row, f.nextSibling);
      rows.push(r);
    });
    if (rows.length) {
      render();
      /* The ring size block sets these selects without firing change. */
      document.addEventListener('click', function () { setTimeout(render, 30); });
      wrap.addEventListener('change', function () { setTimeout(render, 30); });
    }
    wrap.addEventListener('change', function () {
      var vals = Array.prototype.map.call(
        wrap.querySelectorAll('.cji-opt-select'), function (x) { return x.value; });
      var want = vals.join(' / ');
      var btns = grid.querySelectorAll('.cji-variant-btn');
      for (var i = 0; i < btns.length; i++) {
        if ((btns[i].dataset.title || '') === want) { btns[i].click(); return; }
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
